module.exports = __webpack_public_path__ + "fonts/facebook_logo.8c6e99634f7363070ca801e42433eb60.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/login/facebook_logo.png
// module id = 116
// module chunks = 9